import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import {
  CurrencyField,
  form,
  Form as AppForm,
  FormInput,
  FormRow
} from "MODULES/shared/components/Forms";
import { renderIf } from "MODULES/shared/decorators";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import {
  SECOND_EXCHANGE,
  THIRD_EXCHANGE,
  SECOND_SELLER_ID,
  SELLER_ID
} from "MODULES/SalesOrders/constants";
import { ADMIN, ACCOUNTING } from "MODULES/users/constants";
import AutoCompleteField from "MODULES/shared/components/Forms/AutoCompleteField/AutoCompleteField";
import * as actions from "MODULES/SalesOrders/components/shared/FormSections/SellersSection/actions";
import { exchange } from "MODULES/SalesOrders/actions";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";
import { CORE_DUE_DAYS } from "MODULES/RepairOrders/constants";
import { properCase } from "LIB/formatters/text";
import { validate } from "./validate";

const FORM_NAME = "convertToExchange";

function Form(props) {
  const { lineItem, searchSellers, selectedSeller } = props;
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col>
            <Field
              name={SELLER_ID}
              label="Seller"
              placeholder="Search by name..."
              component={AutoCompleteField}
              search={searchSellers}
              formatItem={result => result && result.full_name}
              selectedItem={selectedSeller}
              required
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col>
            <Field
              name={SECOND_SELLER_ID}
              label="2nd Seller"
              placeholder="Search by name..."
              component={AutoCompleteField}
              search={searchSellers}
              formatItem={result => result && result.full_name}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={6}>
            <CurrencyField
              required
              name={EXCHANGE_FEE}
              label={
                lineItem.flat_exchange ? "Flat Exchange Fee" : "Exchange Fee"
              }
            />
          </Col>
          <Col md={6}>
            <Field
              name={CORE_DUE_DAYS}
              component={FormInput}
              label={properCase(CORE_DUE_DAYS)}
              required
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  lineItem: T.shape({
    received: T.bool.isRequired
  }),
  searchSellers: T.func.isRequired,
  seller: T.shape({ full_name: T.string })
};

const meetsExchangeCriteria = renderIf(
  ({
    lineItem: { cancelled, shipped, exchange_type: exchangeType },
    currentUser: { role }
  }) =>
    [ADMIN, ACCOUNTING].includes(role) &&
    !cancelled &&
    (shipped || exchangeType === SECOND_EXCHANGE) &&
    exchangeType !== THIRD_EXCHANGE
);

export const ExchangeComp = withSalesOrder(
  withCurrentUser(meetsExchangeCriteria(Form))
);

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => dispatch(exchange(ownProps.lineItem, data, ownProps.close)),
  searchSellers: (...args) => dispatch(actions.searchSellers(...args))
});

export default connect(
  (state, ownProps) => ({
    initialValues: {
      seller_id: ownProps.lineItem.seller_id,
      [EXCHANGE_FEE]: ownProps.lineItem.flat_exchange
        ? Number(ownProps.lineItem.exchange_fee) -
          Number(ownProps.lineItem.repair_fee)
        : Number(ownProps.lineItem.exchange_fee),
      [CORE_DUE_DAYS]: ownProps.lineItem.core_due_days
    }
  }),
  mapDispatchToProps
)(
  form({
    form: FORM_NAME,
    validate
  })(withFieldAccessors(ExchangeComp))
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/CreateSecondExchange/Form.jsx